import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';

import { parseAxiosError } from 'utils';
import { apiInstance, apiLoaderInstance } from 'api';

interface Error {
  data?: any;
  status?: number;
  message?: string;
}

export const axiosBaseQuery =
  ({
    instance,
  }: {
    instance: AxiosInstance;
  }): BaseQueryFn<
    {
      url: string;
      data?: AxiosRequestConfig['data'];
      method: AxiosRequestConfig['method'];
      headers?: AxiosRequestConfig['headers'];
      timeout?: AxiosRequestConfig['timeout'];
    },
    unknown,
    Error
  > =>
  async ({ url, data, method, timeout, headers }, { signal }) => {
    try {
      const result = await instance({
        url,
        data,
        method,
        signal,
        headers,
        timeout,
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: {
          data: err.response?.data,
          status: err.response?.status,
          message: parseAxiosError(err),
        },
      };
    }
  };

export interface ResponseFuncProps {
  url: string;
  data: AxiosRequestConfig['data'];
}

export const apiQuery = axiosBaseQuery({
  instance: apiInstance,
});

export const apiLoaderQuery = axiosBaseQuery({
  instance: apiLoaderInstance,
});
